import { useState } from 'react';
import { AuthProvider, useAuth } from '../auth/AuthContext';
import LoginPage from '../auth/LoginPage';
import PrivateRoute from '../auth/PrivateRoute';
import Navigation from './Navigation';
import AfterHoursDashboard from './AfterHoursDashboard';
import ReportingPage from '../reports/ReportingPage';
import RequestViewPage from '../reports/RequestViewPage';
import AdminPage from '../admin/AdminPage';
import BmsZonesPage from '../zones/BmsZonesPage';

const AppContent = () => {
  const { isAuthenticated, loading, user, hasRole, logout } = useAuth();
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [requestFilters, setRequestFilters] = useState<any>(null);

  if (loading) {
    return (
      <div className="ah-shell">
        <div className="ah-panel" style={{ maxWidth: 400, margin: '10vh auto' }}>
          <div className="ah-card" style={{ textAlign: 'center' }}>
            <div>Loading...</div>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  // Check if user is tenant-only (no sidebar for tenants)
  const isTenantOnly = user && hasRole('tenant') && !hasRole('admin') && !hasRole('manager');

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <AfterHoursDashboard />;
      case 'reports':
        return (
          <PrivateRoute requireRoles={['admin', 'manager']}>
            <ReportingPage 
              onNavigateToRequests={(filters) => {
                setRequestFilters(filters || {});
                setCurrentPage('requests');
              }}
            />
          </PrivateRoute>
        );
      case 'requests':
        return (
          <PrivateRoute requireRoles={['admin', 'manager']}>
            <RequestViewPage initialFilters={requestFilters || {}} />
          </PrivateRoute>
        );
      case 'admin':
        return (
          <PrivateRoute requireRoles={['admin']}>
            <AdminPage />
          </PrivateRoute>
        );
      case 'zones':
        return (
          <PrivateRoute requireRoles={['admin']}>
            <BmsZonesPage />
          </PrivateRoute>
        );
      default:
        return <AfterHoursDashboard />;
    }
  };

  return (
    <div className={isTenantOnly ? 'layout layout-fullwidth' : 'layout'}>
      {!isTenantOnly && <Navigation currentPage={currentPage} onNavigate={setCurrentPage} />}
      <div className="topbar">
        <div className="page-title">
          {currentPage === 'dashboard' && 'After Hours Dashboard'}
          {currentPage === 'reports' && 'Reports'}
          {currentPage === 'requests' && 'Request Management'}
          {currentPage === 'admin' && 'Admin Panel'}
          {currentPage === 'zones' && 'BMS Zones'}
        </div>
        {isTenantOnly && user && (
          <div style={{ marginLeft: 'auto', fontSize: 14, color: 'var(--muted)' }}>
            {user.username} ({user.role})
            <button onClick={() => {
              logout();
            }}>Sign Out</button>
          </div>
        )}
      </div>
      <div className="content">
        {renderCurrentPage()}
      </div>
    </div>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;
